import { fetchGet } from '../helperApi'

export const fetchContractServicesApi = (contractId, params) => {
    return fetchGet(`contracts/${contractId}/services`, params)
}

export const fetchContractServicesLiveSearchApi = (contractId, params) => {
    return fetchGet(`inspections/filters/live/services/contract/${contractId}`, params)
}
